import React from 'react'
import { Skeleton, Box } from '@mui/material';

export const ContinuarCuestionarioSkeleton = () => {
    return (
        <Box sx={{
            width: 'calc(100%)',
            textAlign: 'center'
        }}>
            <Skeleton variant='rectangular' width={1100} height={200} animation="wave" />
        </Box>
    )
}